import { render } from "./AmendBookingResume.vue?vue&type=template&id=000d531f&scoped=true&lang=pug"
import script from "./AmendBookingResume.vue?vue&type=script&lang=ts"
export * from "./AmendBookingResume.vue?vue&type=script&lang=ts"

import "./AmendBookingResume.vue?vue&type=style&index=0&id=000d531f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-000d531f"

export default script